import { HumanTaskIsRequiredBlockFormField } from './lib/IsRequiredField';
import { type HumanTaskBlockFormFieldsProps } from './types';
import { BlockValueTemplateField } from '../../../../ConfigFields/CodeMirror/FlowTemplate';

export function HumanTaskDateOnlyValueBlockFormFields(props: HumanTaskBlockFormFieldsProps) {
  const { fieldNamePrefix } = props;
  return (
    <>
      <BlockValueTemplateField label="Field label" fieldName={`${fieldNamePrefix}.label`} />
      <BlockValueTemplateField
        label="Variable name"
        fieldName={`${fieldNamePrefix}.variableName`}
      />
      <BlockValueTemplateField
        label="Inbound data"
        fieldName={`${fieldNamePrefix}.initialValue`}
        helperText="Must resolve to a valid YYYY-MM-DD date. Use an empty string when unset."
      />
      <HumanTaskIsRequiredBlockFormField fieldNamePrefix={fieldNamePrefix} />
    </>
  );
}
